import { elevation, themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { carouselStyles } from "@dana/Overrides/Components/Carousel";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

carouselStyles.prevArrowButton = mergeToNew(carouselStyles.prevArrowButton, {
    shape: "rectangle",
    css: css`
        padding: 0;
        min-width: auto;
        min-height: auto;
        z-index: 2;
        justify-content: center;
        background: none;
        border: none;

        ${IconWrapper} {
            svg {
                path {
                    fill: ${themeColors.secondary.danaDarkBlue};
                }
            }
        }

        &:not(:disabled) {
            &:hover {
                background: transparent;
                border: none;

                ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeColors.secondary.danaBrightBlue};
                        }
                    }
                }
            }

            &:focus {
                outline: none;
            }

            &:focus-visible {
                background: transparent;
                border: 1px solid ${themeColors.primary.white};
                box-shadow: ${elevation.focus};
                outline: none;

                ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeColors.secondary.danaBrightBlue};
                        }
                    }
                }
            }
        }

        &:disabled {
            background: none;
            border: none;
            ${IconWrapper} {
                svg {
                    path {
                        fill: ${themeBackgrounds.darkGray};
                    }
                }
            }
        }
    `,
});

carouselStyles.nextArrowButton = mergeToNew(carouselStyles.nextArrowButton, {
    shape: "rectangle",
    css: css`
        padding: 0;
        min-width: auto;
        min-height: auto;
        z-index: 2;
        justify-content: center;
        background: none;
        border: none;

        ${IconWrapper} {
            svg {
                path {
                    fill: ${themeColors.secondary.danaDarkBlue};
                }
            }
        }

        &:not(:disabled) {
            &:hover {
                background: transparent;
                border: none;

                ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeColors.secondary.danaBrightBlue};
                        }
                    }
                }
            }

            &:focus {
                outline: none;
            }

            &:focus-visible {
                background: transparent;
                border: 1px solid ${themeColors.primary.white};
                box-shadow: ${elevation.focus};
                outline: none;

                ${IconWrapper} {
                    svg {
                        path {
                            fill: ${themeColors.secondary.danaBrightBlue};
                        }
                    }
                }
            }
        }

        &:disabled {
            background: none;
            border: none;
            ${IconWrapper} {
                svg {
                    path {
                        fill: ${themeBackgrounds.darkGray};
                    }
                }
            }
        }
    `,
});